module.exports = __webpack_public_path__ + "assets/img/shop_bady.92a9c693.png";